// extracted by mini-css-extract-plugin
export var chevronIcon = "_bw-2";
export var teamName = "_bw-1";
export var teamSwitcherButton = "_bw-0";